module.exports = __webpack_public_path__ + "running-ninja.png";